import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "as", "extend"];
import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
var style = {
  display: 'inline'
};
export var Inline = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$as = _ref.as,
      As = _ref$as === void 0 ? 'span' : _ref$as,
      extend = _ref.extend,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useFela = useFela(props),
      css = _useFela.css;

  return /*#__PURE__*/React.createElement(As, _extends({}, props, {
    ref: ref,
    className: css(style, extend) + (className ? ' ' + className : '')
  }), children);
});
Inline.displayName = 'Inline';
Inline.propTypes = {
  /** Any valid React element, function, or a string specifying a name for an HTML element */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.elementType, PropTypes.func]),

  /** An object containing valid CSS style declarations */
  extend: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.array]),

  /** A JSX node */
  children: PropTypes.node,

  /** Add an additional custom className to element. Warning: make sure it doesn't collide with the classNames being generated for the atomic CSS **/
  className: PropTypes.string
};